<template>
  <div>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">
        <app-i18n code="home.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/fan' }">
        <app-i18n code="entities.fan.menu"></app-i18n>
      </el-breadcrumb-item>
      <el-breadcrumb-item>
        <app-i18n code="entities.fan.view.title"></app-i18n>
      </el-breadcrumb-item>
    </el-breadcrumb>

    <div class="app-content-page">
      <h1 class="app-content-title app-content-title--hidden">
        <app-i18n code="entities.fan.view.title"></app-i18n>
      </h1>

      <div class="app-page-spinner" v-if="loading" v-loading="loading"></div>

      <app-fan-view-toolbar v-if="record"></app-fan-view-toolbar>

      <el-form
        :label-position="labelPosition"
        :label-width="labelWidthForm"
        @submit.prevent.native
        class="form"
        v-if="record"
      >
        <app-view-item-text :label="fields.id.label" :value="presenter(record, 'id')"></app-view-item-text>

        <app-view-item-text :label="fields.name.label" :value="presenter(record, 'name')"></app-view-item-text>

        <app-view-item-text :label="fields.lastName.label" :value="presenter(record, 'lastName')"></app-view-item-text>

        <app-view-item-image :label="fields.picture.label" :value="presenter(record, 'picture')"></app-view-item-image>

        <app-view-item-text :label="fields.uid.label" :value="presenter(record, 'uid')"></app-view-item-text>

        <app-view-item-relation-to-many
          :label="fields.teams.label"
          :permission="fields.teams.readPermission"
          :url="fields.teams.viewUrl"
          :value="presenter(record, 'teams')"
        ></app-view-item-relation-to-many>

        <app-view-item-text :label="fields.createdAt.label" :value="presenter(record, 'createdAt')"></app-view-item-text>

        <app-view-item-text :label="fields.updatedAt.label" :value="presenter(record, 'updatedAt')"></app-view-item-text>
      </el-form>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import FanViewToolbar from '@modules/fan/components/fan-view-toolbar.vue';
import { FanModel } from '@modules/fan/fan-model';

const { fields } = FanModel;

export default {
  name: 'app-fan-view-page',

  props: ['id'],

  components: {
    [FanViewToolbar.name]: FanViewToolbar,
  },

  computed: {
    ...mapGetters({
      labelPosition: 'layout/labelPosition',
      labelWidthForm: 'layout/labelWidthForm',
      record: 'fan/view/record',
      loading: 'fan/view/loading',
    }),

    fields() {
      return fields;
    },
  },

  async created() {
    await this.doFind(this.id);
  },

  methods: {
    ...mapActions({
      doFind: 'fan/view/doFind',
    }),

    presenter(record, fieldName) {
      return FanModel.presenter(record, fieldName);
    },
  },
};
</script>
